import { XStack, View } from "tamagui";
import TextCustom, { TextSize } from "@components/TextCoustom";
import { IconType } from "react-icons";

/*******************************************************************
 * Type: Modal Component
 * Description:  Modal 元件上方的 title + icon
/******************************************************************/

interface Props {
  title: string;
  left?: {
    icon: IconType;
    func: () => void;
    bg?: string;
  };
  right?: {
    icon: IconType;
    func: () => void;
    bg?: string;
  };
  bgColor?: string;
  px?: number | string;
  other?: any;
}

const SheetHeader: React.FC<Props> = ({
  title,
  left,
  right,
  px = "$3",
  other,
  bgColor = "#FFF",
}) => {
  return (
    <XStack
      bg={bgColor}
      py={"$4"}
      px={px}
      w={"100%"}
      justifyContent="space-between"
      alignItems="center"
      {...other}
    >
      <View bg={bgColor}>
        {left && (
          <View
            onPress={left.func}
            bg={left.bg ? left.bg : "$colorTransparent"}
            p={left.bg ? "$2" : "$0"}
            borderRadius={"$2"}
          >
            <left.icon size={23} />
          </View>
        )}
      </View>

      <TextCustom type={TextSize.NORMAL} str={title} bold />
      <View>
        {right && (
          <View
            onPress={right.func}
            p={right.bg ? "$2" : "$0"}
            bg={right.bg ? right.bg : "$colorTransparent"}
            borderRadius={"$2"}
          >
            <right.icon size={23} />
          </View>
        )}
      </View>
    </XStack>
  );
};

export default SheetHeader;
